import gql from 'graphql-tag'

const GENERATE_TRACEABILITY = gql`
    mutation createTraceability ($input: TraceabilityInput) {
        createTraceability (input: $input) {
        status,
        message,
        data {
            idUser,
            createdAt,
            actionId,
            action,
            quantityAffected
        }
        }
    }
`;

export default GENERATE_TRACEABILITY;
